import Dynamic from '@base/Dynamic/Dynamic';
import constants from './constants';
import { useLocalLoginInfo } from './Context/LoginLocalInfo';
import LoginWrapper from './Common/LoginWrapper';

const PromotionHeader = Dynamic(() => import('./Promotion/PromotionHeader'));
const TAndCNotice = Dynamic(() => import('./Footer/TAndCNotice'));
const Trouble = Dynamic(() => import('./Footer/Trouble'));
const NewTrouble = Dynamic(() => import('./Footer/NewTrouble'));

const LoginComponentLayout = ({ children }) => {
  const { accountType, source, hideHelp } = useLocalLoginInfo();
  const { IsNewLoginModal } = useLocalLoginInfo();
  const showTermsAndConditions = accountType === constants.ACCOUNT_TYPE_SIGNUP;
  const showTroubleBlock =
    accountType === constants.ACCOUNT_TYPE_LOGIN && !hideHelp;
  return (
    <LoginWrapper $source={source} className="login-wrapper">
      <PromotionHeader />
      {children}
      {showTermsAndConditions && <TAndCNotice />}
      {showTroubleBlock && IsNewLoginModal && <NewTrouble />}
      {showTroubleBlock && !IsNewLoginModal && <Trouble />}
    </LoginWrapper>
  );
};

export default LoginComponentLayout;
